<template>
  <AppInputField class="app-switch">
    <input
      :checked="value"
      v-bind="$attrs"
      type="checkbox"
      class="app-switch__input"
      @change="updateStatus($event.target.checked)"
    />
    <!-- <label v-if="label" @click="check" :class="`--${labelPosition}`">{{ label }}</label> -->
    <div class="app-switch__circle"></div>
    <div class="app-switch__text on">
      <slot name="text-on" />
    </div>
    <div class="app-switch__text off">
      <slot name="text-off" />
    </div>
    <div class="app-switch__background"></div>
  </AppInputField>
</template>

<script>
// Components
import AppInputField from 'Ui/AppInputField'

export default {
  name: 'AppSwitch',
  inheritAttrs: false,

  components: {
    AppInputField,
  },

  props: {
    label: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Boolean],
      required: true,
    },

    labelPosition: {
      type: String,
      default: 'left',
    },
  },

  methods: {
    check(event) {
      const checkbox = event.target.parentElement.querySelector('.app-switch')
      if (checkbox.disabled) return
      checkbox.checked = !checkbox.checked
      this.updateStatus(checkbox.checked)
    },

    updateStatus(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style scoped>
.app-switch {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 48px;
  max-width: max-content;
  height: 28px;
  background-color: var(--c-secondary-400);
  padding: 5px;
  border-radius: 15px;
  transition: var(--transition--400);
  overflow: hidden;
}

.app-input-field label {
  cursor: pointer;
  margin-left: 11px;
}

.app-switch label.--left {
  order: -1;
  margin-left: 0;
  margin-right: 11px;
}

.app-switch__input {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  cursor: pointer;
  outline: none;
  opacity: 0;
}

.app-switch__circle {
  position: absolute;
  content: '';
  width: 20px;
  height: 20px;
  left: 4px;
  border-radius: inherit;
  background-color: #fff;
  backface-visibility: hidden;
  pointer-events: none;
  box-shadow: 0 2px 10px -2px rgba(0, 0, 0, 0.3);
  transition: var(--transition--400);
  z-index: 1;
}

.app-switch__input:checked ~ .app-switch__circle {
  left: calc(100% - 24px);
  /* background-color: var(--c-secondary-700); */
}

.app-switch__text {
  position: relative;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--c-primary);
  letter-spacing: 0.2px;
  padding: 5px 5px 5px 25px;
  overflow: hidden;
  white-space: nowrap;
  pointer-events: none;
  transition: var(--transition--400);
  z-index: 1;
}

.app-switch__text.on {
  position: absolute;
  opacity: 0;
  transform: translate(-100%);
}

.app-switch__input:checked ~ .app-switch__text {
  padding-left: 5px;
  padding-right: 25px;
  color: #fff;
}

.app-switch__input:checked ~ .app-switch__text.off {
  position: absolute;
  opacity: 0;
  transform: translate(100%);
}

.app-switch__input:checked ~ .app-switch__text.on {
  position: relative;
  opacity: 1;
  transform: translate(0);
}

.app-switch__background {
  position: absolute;
  width: 100%;
  height: 100%;
  /* left: -100%; */
  border-radius: inherit;
  padding-bottom: 100%;
  background-color: transparent;
  pointer-events: none;
  z-index: 0;
  transition: var(--transition--400);
}

.app-switch__input:checked ~ .app-switch__background {
  /* left: 0; */
  background-color: var(--c-primary);
}
</style>
